import { iconColorGetter, TAILLE_ICON_LARGEUR, TAILLE_ICON_HAUTEUR, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';


export const MINIMUM_CLUSTER_SIZE = 3;
export const ISOCHRONE_MAX = 60;
export const ISOCHRONE_MIN = 5;
export const ISOCHRONE_INTERVAL = 5;
export const ISOCHRONE_DEFAULT = 10;
export const RAYON_MAX = 200;
export const RAYON_MIN = 1;
export const RAYON_INTERVAL = 1;
export const ZOOM_DEFAULT_LC = 16;
export const RAYON_DEFAULT = 15;

export const TYPE_LAYER_EMPTY = 'empty';
export const TYPE_LAYER_GEO_MARKETING_DEMO = 'demo';
export const TYPE_LAYER_GEO_MARKETING_ECO = 'eco';
export const TYPE_LAYER_GEO_MARKETING_CONCU = 'concu';

export const ZOOM_DEFAULT_RESEAUX = 6;
export const CENTER_RESEAUX_DEFAULT = {
  lat: 48.85661400000001,
  lng: 2.3522219000000177,
};
export const RESEAU_FROM_VENTES_RESEAUX = 'reseauxFromVentesReseaux';
export const FACES_FROM_VENTES_RESEAUX = 'facesFromVentesReseaux';
export const PANNEAUX_FROM_VENTES_LC = 'panneauxFromVentesLC';
export const PANNEAUX_FROM_VENTES_NUMERIQUES = 'panneauxFromVentesNumerique';

export const COULEUR_PUCE_DEFAULT = '#009CE0';
export const OPTION = {
  editable: false,
  fillColor: '#444488',
  fillOpacity: 0,
  strokeColor: '#555599',
  strokeOpacity: 0.8,
  strokeWeight: 1,
};
export const MARKER_POINT_NOIR = {
  url: 'static/img/icon_position.png',
  size: { width: TAILLE_ICON_LARGEUR * TAILLE_ICON_GRAND / TAILLE_ICON_HAUTEUR, height: TAILLE_ICON_GRAND, f: 'px', b: 'px' },
  scaledSize: { width: TAILLE_ICON_LARGEUR * TAILLE_ICON_GRAND / TAILLE_ICON_HAUTEUR, height: TAILLE_ICON_GRAND, f: 'px', b: 'px' },
};

export const MARKER_POINT_DEFAUT = iconColorGetter(COULEUR_PUCE_DEFAULT);

export const MAP_TYPE_CONTROL_OPTIONS = {
  mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map'],
};
export const MAP_TYPE_NAME = 'Cacher POI';

export const STYLE_MAPS_POI_HIDDEN = [
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/configuration/carteConf.js